/* global jQuery linklanguage */

import selectn from 'selectn'
import config from '../../../config'
import qs from 'query-string'

export const webviews = {
  // cache frequently used elements
  elems : {
    // Attach on App only if body has class webview
    wrapper : `body.webview #${config.uid}`,
    videoPlayButton : '.video-play-button',
    contentContainer: '.main-content.react-content',
    //bloom: '.highlight.gamepackage_bloom',
    // List of elements on which webviews interceptor should not be attached
    ignore : [ '.back-to-top', '.react-router-link', '.accordion-header a', '.commentary a.icon-font-before ', '.more-link', 'a.button-filter-alt' ].join(',')
  },
  interceptorAttached : false,
  allVideos : [],
  sliderVideos: [],
  pageInfo : {},
  /**
   * Get page information, used for app
   * @param  {String} platform valid platform as per isPlatformSupported
   * @param  {Object} meta     title, canonical, description props
   * @return {Object}          commandParameters
   */
  getPageInfo: function (platform = '', meta = {} ) {
    // default return value
    let commandParameters = {}
    // Get canonical and return if it's empty string
    let canonical = meta.canonical || ''
    if (canonical === '' || webviews.isPlatformSupported(platform) === false) {
      return commandParameters
    }
    // Construct the full url if missing
    if(canonical.indexOf('http://') === -1) {
      canonical = 'http://' + window.location.hostname + canonical
    }
    // webview part which needs to be stripped off
    let webviewPart = `/${platform}/webview`
    // default value of sharable URL
    let sharableUrl = ''
    // Remove webview part only if it's found
    if (canonical.indexOf(webviewPart) > -1) {
      sharableUrl = canonical.replace(webviewPart, '')
    }
    if (typeof encodeURIComponent === 'function') {
      sharableUrl = encodeURIComponent(sharableUrl)
    }

    //console.info('sharableUrl', sharableUrl)

    // prep return data
    /*
    commandParameters = {
      headline : meta.title || '',
      description : meta.description || '',
      shareurl : sharableUrl,
      platform :  platform,
      matchId: meta.matchId || '',
      matchDescription: meta.matchDescription || '',
      leagueId: meta.leagueId || '',
      leagueUID: meta.leagueUID || '',
      leagueName: meta.leagueName || '',
      sport: meta.sport || '',
      gameState: meta.gameState || '',
      shortTitle: meta.shortTitle || '',
      competitionUID: meta.competitionUID || ''
    }
    */
    // Updated command parameters as per request from webview channel
    commandParameters = {
      headline : meta.title || '',
      gameId: meta.gameId || '',
      description: meta.matchDescription || '',
      leagueId: meta.leagueId || '',
      leagueUID: meta.leagueUID || '',
      leagueName: meta.leagueName || '',
      sport: meta.sport || '',
      gameState: meta.gameState || '',
      shortTitle: meta.shortTitle || '',
      competitionUID: meta.competitionUID || '',
      shareurl : sharableUrl,
      platform :  platform
    }
    return commandParameters
  },


  /**
   * Get video's URL
   * @param  {Object} videoObj video node as received from feed
   * @return {String}          video URL if found else empty string
   */
  getVideoUrl: function (videoObj = {}) {
    let videoUrl = selectn('links.mobile.streaming.href', videoObj) || ''
    return videoUrl
  },

  /**
   * Get video object by looking up in multiple sources
   *
   * @param  {Number}  id           video id
   * @param  {Boolean} isLecVideo   is function called via a LEC clip
   * @return {Object}               clicked video details
   */
  getVideoNodeFromArray: function (id, isLecVideo) {
    let videoNode = {}
    /**
     * If it's a LEC video, we also need to lookup in
     * lecclips array - on commentary tab
     * rosterVideos array - on scorecard and current innings section
     */
    // keep the global array unchanged and create a new array for all the videos
    let allGamepackageVideos = webviews.allVideos || []
    if(isLecVideo) {
      if (webviews.lecclips.length > 0) {
        allGamepackageVideos = allGamepackageVideos.concat(webviews.lecclips)
      }
      if (webviews.rosterVideos.length > 0) {
        //console.info('rosterVideos', rosterVideos)
        allGamepackageVideos = allGamepackageVideos.concat(webviews.rosterVideos)
      }
    }
    if((webviews.allVideos.length === 0) && (webviews.sliderVideos.length > 0)) {
      allGamepackageVideos = allGamepackageVideos.concat(webviews.sliderVideos)
    }
    // Iterate over all videos and extract clicked video's details
    for (var i = 0; i < allGamepackageVideos.length; i++) {
      let currentVideo = allGamepackageVideos[i] || {}
      if (currentVideo.id === id) {
        videoNode = currentVideo
        break
      }
    }
    //console.log('======== videoNode',videoNode)
    return videoNode
  },
  /**
   * Get data for a video from list of video objects. Modify it as required by
   * App.
   * @param  {String} id        video id
   * @param  {Boolean} isCarousel is this video clicked on carousel section?
   * @param  {Boolean} isVideosTab is this video clicked on videos tab
   * @param  {Boolean} isLecVideo  is this a LEC video clicked?
   * @param  {Boolean} isContent  is this a preview/report tab
   * @param  {Boolean} isVideoEmbed is this video embedded in commentary
   * @param  {Object}  dataVideoInfo    videoInfo extracted from data attrs of embed
   * @return {Object}           data for a particular video (with videoUrlList data)
   */
  getVideoDetails: function (id = '' , isCarousel = false, isVideosTab = false, isLecVideo = false, isContent = false, isVideoEmbed=false, dataVideoInfo={}) {


    //console.info('id:', id,'\nisCarousel:',isCarousel,'\nisVideosTab:',isVideosTab,'\nisLecVideo:',isLecVideo,'\nisContent',isContent)


    // default video details of the passed id
    let videoNode = {}
    // Video details which are required for App
    let appVideo = {}

    // Return if id is missing or if there are no videos
    if (id === '' || (isVideoEmbed === false && selectn('allVideos.length', webviews) === 0 && selectn('sliderVideos.length', webviews) === 0)) {
      return appVideo
    }
    if (isVideoEmbed) {
      videoNode = dataVideoInfo
    } else {
      //get video node by search in all videos and lec clips
      videoNode = webviews.getVideoNodeFromArray(id, isLecVideo)
    }
    //console.log('videoNode', videoNode)

    // By default videoUrlList should be an empty array
    videoNode.videoUrlList = []

    /**
     * If a video from carousel was clicked, get it's index from the carousel.
     * Create an array of urls from clicked index to length of list.
     */
    if (isCarousel === true) {
      // default clicked index
      let clickedVideoIdx
      // number of slider videos
      let numSliderVideos = webviews.sliderVideos.length

      // Iterate over all slider videos and match current video id with id
      for (var k = 0; k < numSliderVideos; k++) {
        let currentSliderVideo = webviews.sliderVideos[k] || {}
        let currentVideoId = currentSliderVideo.id || ''
        // extract streaming url
        let mobileUrl = webviews.getVideoUrl(currentSliderVideo)
        // if id matches with current id, set index of clicked video
        if (currentVideoId === id) {
          clickedVideoIdx = k
        }
        //console.info('k %d clicked %d', k, clickedVideoIdx)

        /**
         * Push all videos from index of clicked video to end of list
         * e.g. if 2nd video was clicked, video url list should have
         * urls of 2,3,4 to nth
         */
        if (k >= clickedVideoIdx) {
          // Push to array only if url is not empty string
          if (mobileUrl !== '') {
            videoNode.videoUrlList.push(mobileUrl)
          }
        }
      }
    }

    // For video tab, populate videoUrlList with clicked video's streaming URL
    if (isVideosTab || isLecVideo || isContent || isVideoEmbed) {
      let clickedVideoUrl = webviews.getVideoUrl(videoNode)
      if (clickedVideoUrl !== '') {
        videoNode.videoUrlList.push(clickedVideoUrl)
      }
    }

    console.info('videoUrlList', videoNode.videoUrlList)

    // Start setting props required for App
    appVideo = {
      geoRestrictions : undefined,
      androidSource: videoNode.source,
      iosSource: videoNode.source
    }

    // Properties which need to be picked from videoNode and added tp appVideo
    let allRequiredProps = [ 'id', 'headline', 'source', 'tracking',
      'deviceRestrictions', 'links', 'videoUrlList' ]

    // Iterate over all props and set them in appVideo if they have truthy value
    for (var j = 0; j < allRequiredProps.length; j++) {
      let key = allRequiredProps[j]
      if (videoNode.hasOwnProperty(key) && videoNode[key]) {
        appVideo[key] = videoNode[key]
        // Android app needs video id in videoId key so set another property
        if (key === 'id') {
          appVideo.videoId = videoNode[key]
        }
      }
    }
    //console.log('appVideo', appVideo)
    return appVideo
  },

  /**
   * Check if this is a mobile platform supported by webview implementation
   * @param  {String}  platform ios/android/windows
   * @return {Boolean}          true if supported else false
   */
  isPlatformSupported: function (platform = '') {
    // Platforms currently supported for webviews
    const validPlatforms = [ 'ios','android', 'windows' ]
    if(validPlatforms.indexOf(platform) > -1) {
      return true
    }
    //console.info('%s platform is not supported, webviews will not init' , platform)
    return false
  },

  /**
   * Wrapper to Link Language library or the bridge which connects JavaScript
   * with Native App code. Here it wraps window.espn.nativeBridge.sendMessage
   * method in a try-catch block.
   *
   * @param  {String}   command  commandName
   * @param  {Object}   params   params which need to be passed
   * @param  {Function} callback callback function name
   * @return {undefined}            undefined
   */
  callLinkLang: function (command, params, callback) {
    try{
      window.espn.nativeBridge.sendMessage(command, params, callback)
    }
    catch(e) {
      if (console && console.log) {
        console.log('callLinkLang error:', e, typeof e)
      }
    }
  },
  /**
   * [loadInBrowser Wrapper to window.espn.nativeBridge.loadMinibrowser function]
   * @param  {string} url [path of the url that needs to be opened in minibrowser]
   * @return {undefined}     [description]
   */
  loadInBrowser: function (url) {
    try{
      window.espn.nativeBridge.loadMinibrowser(url)
    }
    catch(e) {
      if (console && console.log) {
        console.log('loadInBrowser error:', e, typeof e)
      }
    }
  },

  /**
   * [sharePageInfo function to send the data for sharing in app]
   * @param {String} platform name of platform
   * @param {Object} meta meta
   * @return {[type]} [object with page meta information]
   */
  sharePageInfo: function ( platform = '', meta = {} ) {
    webviews.pageInfo = webviews.getPageInfo(platform, meta) || {}
    // Setup a public method so that App can access it.
    if (typeof window !== 'undefined') {
      // This function is used by android app
      window._getPageInfo = function () {
        try{
          /**
           * We need this for lower androids which can't read directly
           * returned json objects. This is added for testing share page info
           * on QA site. After verifiying on QA, keep only one method of
           * sharing page info with android.
           *
           * This function call is as provided by Tushar Garg.
           */
          linklanguage.receiveValueFromJs(JSON.stringify(webviews.pageInfo))
        }
        catch(e) {
          //console.log('e, typeof e', e, typeof e)
          // This is used by latest androids. Commented as asked by Tushar.
          return webviews.pageInfo
        }
      }
      // Also adding as an object for ios app
      window._pageInfo = Object.assign({}, webviews.pageInfo)
      //console.info('window._pageInfo', window._pageInfo)
      // New Link language call for ios app, noredirect param used for webview testing in browser
      if(platform === 'ios') {
        let querystr = qs.parse(window.location.search)
        let noredirect = (querystr.noredirect === 'true') ? true : false
        if(!noredirect) {
          webviews.callLinkLang('onLoadComplete', { pageInfo: Object.assign({}, webviews.pageInfo) }, null)
        }
      }
      // end

    }
  },

  /**
   * Load clubhouse inside Native App
   * @param  {Object} $this jQuery selected object
   * @return {undefined}       undefined
   */
  loadClubhouse: function ($this) {
    let commandParameters = {}
    commandParameters.uid = $this.data('uid')
    if(typeof commandParameters.uid !== 'undefined') {
      webviews.callLinkLang('loadClubhouseWithUID', commandParameters, null)
    }
  },

  /**
   * Load a points table URL in minibrowser
   * @param  {Object}  $this                jQuery selected object
   * @param  {Boolean} isMiniBrowserPresent is mini browser available
   * @return {undefined}                    undefined
   */
  loadPointsTable: function ($this, isMiniBrowserPresent) {
    let leagueUid = jQuery('#gamepackage-header-wrap').data('leagueUid')
    if(typeof leagueUid !== 'undefined' && isMiniBrowserPresent) {
      let pageURL = 'http://www.espn.com/allsports/scorecenter/apps/webviews/standings/build?uid='+leagueUid+'&appName=sportscenter'
      if (typeof encodeURIComponent === 'function') {
        /**
         * Commenting out encodeURIComponent for now since loadMinibrowserWithURL does not decode URL
         */
        //pageURL = encodeURIComponent(pageURL)
      }
      webviews.loadInBrowser(pageURL)
    }
  },

  /**
   * Load video inside Native App
   * @param  {Object} e Event handler object
   * @return {undefined}        undefined
   */
  loadVideo: function (e) {
    e.preventDefault()
    e.stopImmediatePropagation()
    let $this = jQuery(this)
    // Init videoId
    let videoId
    // Check type of page
    let isVideosTab = $this.parents('#gamepackage-videos').length > 0 ? true : false
    let isCarousel = $this.parents('#carousel').length > 0 ? true : false
    //check if element is a video embedded in commentary
    let parentElm = $this.parents('.video-embed')
    let isVideoEmbed = parentElm.length > 0 ? true : false
    let isContent = $this.parents(webviews.elems.contentContainer).length > 0 ? true : false
    let videoInfo = {}
    // Get videoId from the data attrs
    if (isVideosTab || isContent) {
      videoId = $this.data('id')
      console.info('Videos Tab or Content Tab or commentary-vod-embed', videoId)
    }
    if (isCarousel) {
      videoId = $this.parents('.video-carousel').data('id')
      console.info('Carousel', videoId)
    }
    if(isVideoEmbed) {
      videoInfo = parentElm.data('video-info')
      videoId = videoInfo.id
    }
    if(typeof videoId !== 'undefined') {
      let commandParameters = {}
      commandParameters = webviews.getVideoDetails(videoId, isCarousel, isVideosTab, false, isContent, isVideoEmbed, videoInfo)
      console.info('Video play button clicked')
      webviews.callLinkLang('loadVideo', commandParameters, 'loggingCallback')
    }
  },

  /**
   * Load video inside Native App
   * @param  {Object} e     Event handler object
   * @param  {Object} $this Reference to jQuery selection
   * @return {undefined}       undefined
   */
  loadLecVideo: function (e, $this) {
    e.preventDefault()
    e.stopImmediatePropagation()
    // Init videoId
    let videoId
    // Set type of page
    let isVideosTab = false
    let isCarousel = false
    let isLecVideo = true


    // Get videoId from the data attrs
    videoId = $this.data('id')
    console.info('loadLecVideo', videoId)
    if(typeof videoId !== 'undefined') {
      let commandParameters = {}
      commandParameters = webviews.getVideoDetails(videoId, isCarousel, isVideosTab, isLecVideo, false)
      console.info('Video play button clicked')
      webviews.callLinkLang('loadVideo', commandParameters, 'loggingCallback')
    }
  },

  /**
   * Click handler to intercept all link clicks inside body.webview #reduxion
   * @param  {Object} e Event handler object
   * @return {undefined}   undefined
   */
  interceptor: function (e) {
    console.info(`body.webview #${config.uid} Link clicked`)
    let $this = jQuery(this)
    // All links with app_partial class should be opened in App
    let isNativeAppLink = $this.hasClass('app_partial')
    // Extract href
    let pageURL = $this.attr('href') || '#'
    // gather what type of link this is
    let linkType = $this.data('linktype')

    let isMiniBrowserPresent = false
    if (selectn('espn.nativeBridge', window)) {
      isMiniBrowserPresent = typeof window.espn.nativeBridge.loadMinibrowser === 'function' ? true : false
    }

    // If it's a native app link, call repective function as per linkType
    if(isNativeAppLink) {
      e.preventDefault()
      e.stopImmediatePropagation()
      console.info('Native App link of type %s', linkType)
      if (linkType === 'clubhouse') {
        webviews.loadClubhouse($this)
      }
      else if (linkType === 'video') {
        webviews.loadVideo($this)
      }
      else if (linkType === 'lecvideo') {
        webviews.loadLecVideo(e, $this)
      }
    }
    // If it's not a native app link
    else if(isMiniBrowserPresent) {
      e.stopImmediatePropagation()
      e.preventDefault()

      // if linkType table, Init functionality for the same
      let sport = webviews.pageInfo && webviews.pageInfo.sport
      let isRugbySport = (sport === 'rugby' || sport === 'rugby-league') ? true : false
      if (linkType === 'table' && !isRugbySport) {
        console.info('Points table link click')
        webviews.loadPointsTable($this, isMiniBrowserPresent)
      }
      else{
        console.info('Regular href. Opening in minibrowser', pageURL)
        if (typeof encodeURIComponent === 'function') {
          //pageURL = encodeURIComponent(pageURL)
        }
        webviews.loadInBrowser(pageURL)
      }

    }
  },

  /**
   * Init webviews functionality
   * @param  {String} platform      ios/android/windows
   * @param  {Object} meta          meta data for page
   * @param  {Array} allVideos      All videos for this match
   * @param  {Array} sliderVideos   slider/carousel videos
   * @param  {Array} lecclips       All lecclips for this match
   * @param  {Array} rosterVideos   videos in player rosters
   * @param  {Array} action         page onload or onstatechange
   * @return {undefined}            undefined
   */
  init: function (platform = '' , meta, allVideos = [], sliderVideos = [], lecclips = [], rosterVideos = [], action) {
    // Do not proceed if this platform is not supported
    if (webviews.isPlatformSupported(platform) === false) {
      return
    }
    //console.info('%s platform is supported',platform)

    //calling sharePageInfo so that app gets latest info for sharing on load
    if(action === 'init') {
      webviews.sharePageInfo( platform, meta )
    }

    //check if device detection is available
    // console.info('window.espn_ui.device', selectn('espn_ui.device', window))


    //console.info('lecclips', lecclips)
    //console.info('rosterVideos', rosterVideos)
    //console.info('action', action)
    //console.info('sliderVideos', sliderVideos)

    // Push latest videos to allVideos & sliderVideos property
    webviews.allVideos = allVideos
    webviews.sliderVideos = sliderVideos
    webviews.lecclips = lecclips
    webviews.rosterVideos = rosterVideos

    // Attach click handler only once based on the flag
    if (webviews.interceptorAttached === false) {
      // Attach click handler for all anchor links except those with class react-router-link
      let $parentElem = jQuery(webviews.elems.wrapper)
      //console.info('webviews.elems.ignore', webviews.elems.ignore)
      $parentElem.on('click', `a:not(${webviews.elems.ignore})`, webviews.interceptor)
      // Attach click handler on video elements
      $parentElem.on('click', webviews.elems.videoPlayButton, webviews.loadVideo)
      console.info(`Attached interceptor on body.webview #${config.uid}`)
      webviews.interceptorAttached = true
    }
  },

  disableInterceptor: function () {
    console.info('disableInterceptor')
    // Disable click handler for all anchor links except those with class react-router-link
    let $parentElem = jQuery(webviews.elems.wrapper)
    $parentElem.off('click', `a:not(${webviews.elems.ignore})`, webviews.interceptor)
    // Disable click handler on video elements
    $parentElem.off('click', webviews.elems.videoPlayButton, webviews.loadVideo)
  }

}


export default webviews



// WEBPACK FOOTER //
// ../app/lib/utils/webviews.js